import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DxButtonModule, DxTextBoxModule, DxPopupModule, DxScrollViewModule } from 'devextreme-angular';
import { CommonModule } from '@angular/common';
import { CtlSablonComponent } from '../ctl-sablon/ctl-sablon.component';
import { LabelMode } from 'devextreme/common';
import { UtilsService } from '../../../services/utils.service';
import { OrtakService } from '../../../services/ortak.service';
import { CtlVgasBirimDosyaBelgeAramaComponent } from './ctl-vgas-birim-dosya-belge-arama/ctl-vgas-birim-dosya-belge-arama.component';
import { VgasBirimDosyaBelgeService } from './ctl-vgas-birim-dosya-belge.service';

@Component({
  selector: 'dk-ctl-vgas-birim-dosya-belge',
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlVgasBirimDosyaBelgeAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    CtlSablonComponent,
  ],
  providers: [VgasBirimDosyaBelgeService],
  templateUrl: './ctl-vgas-birim-dosya-belge.component.html',
  styleUrls: ['./ctl-vgas-birim-dosya-belge.component.scss'],
})
export class CtlVgasBirimDosyaBelgeComponent implements OnInit {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode:LabelMode = null;
  public crudPopupVisible = false;
  public title!: string;
public isFirst = true;
  public control!: any;
  controlName = "vGasBirimDosyaBelge";
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public data: any;
  @Input() code: any;
  @Input() birimKod: number;
  @Input() dosyaPlanKod: string;
  @Input() validationRulesMap!:any[];
  @Input() validationV2= false;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: VgasBirimDosyaBelgeService, private utilsService: UtilsService, private ortakService: OrtakService) {}

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
    this.service.setParams(this.birimKod, this.dosyaPlanKod,this.isReadOnly,this.isBindCheck)
  }
    ngOnChanges(changes: SimpleChanges) {
         
      if (changes['isReadOnly'] || changes['isBindCheck']) {
    this.service.setParams(this.birimKod, this.dosyaPlanKod,this.isReadOnly,this.isBindCheck)
        }
    }
  getControl(){
    this.ortakService.getControl(this.controlName)
    .subscribe((data) => {
      this.control = data?.controlMetadata;
             //this.service.getDlist(this.control?.dlistCode);
      this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
      //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if(data?.controlMetadata.dlistMetadata.baseEntity){
          if(this.labelText === "")this.labelText = this.control.controlDescription;
          if(this.code && this.control) this.getData(this.code,true)
if(this.isFirst) this.isFirst = false;;
        }
    });
  }


  searchClick() {
    this.crudPopupVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if (e === '' || e === null) this.clear();
    else if(!this.isFirst) this.getData(e);
    this.isFirst = false;
  }

  getData(code: any, isSetData?: boolean) {

    this.data = this.service.getData(Number(code),this.control,this.control.dlistMetadata.baseEntity,isSetData);
    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = '';
        this.title = result[0].BelgeAd;
        this.code = result[0].BelgeTuruKod;
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }
    });

  }
  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.data = result.data;
      this.code = result.data.BelgeTuruKod;
      this.dataResult.emit(this.data);
    } 
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}


